/**
 * QUIPWA — cards_index.json reconciliation.
 *
 * Pure, so it can be tested without dragging Drive and auth into the test run.
 * See CardIndexService for how it's used.
 */

import type { CardsIndexFile, Flashcard } from './card-index-service.ts';

/**
 * Union two index snapshots by card id, preferring `local` on collision.
 *
 * Safe precisely because this index is append-only: cards are added and never
 * edited or removed here, so there is no divergent edit a union could silently
 * discard. If deletion is ever added, this needs tombstones instead.
 */
export function unionCards(local: CardsIndexFile, remote: CardsIndexFile): CardsIndexFile {
  const byId = new Map<string, Flashcard>();
  for (const card of remote.cards) byId.set(card.id, card);
  for (const card of local.cards) byId.set(card.id, card);

  return {
    version: 1,
    synced_at: Math.max(local.synced_at, remote.synced_at),
    cards: [...byId.values()].sort((a, b) => a.created_at - b.created_at),
  };
}
